<template>
  <div id="app">
    <img class="logo" src="./assets/logo--pokeapi.png">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo {
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue